import { useQuery } from '@tanstack/react-query';
import useAuth from 'hooks/useAuth';
import fetchMotivesData from '../services/fetchMotivesData';

export default function useMotivesData() {
	const { accessToken } = useAuth();

	const motivesQuery = useQuery({
		queryKey: ['motives'],
		queryFn: () => fetchMotivesData(accessToken),
		staleTime: Infinity,
		retry: false,
	});

	return motivesQuery;
}
